import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

interface AppInfo {
  env: string
}

export function useAppInfo() {
  return useQuery({
    queryKey: ['app-info'],
    queryFn: async () => {
      const { data } = await axios.get<AppInfo>('/info')
      return data
    },
    staleTime: Infinity,
  })
}
